import React from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import { useFetchData } from 'services/queries';
import Card from 'components/card';
import { Button } from '@mui/material';
import { BsArrowLeft, BsPencilSquare } from "react-icons/bs";
import { CATEGORY_CHOICES } from 'constants';

const AdditionalCostSubcategoryView = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  
  const { data, isLoading, error } = useFetchData(
    `additional-cost/subcategory/${id}/`,
    true
  );

  // Convert CATEGORY_CHOICES array to object for easy lookup
  const categoryDisplay = CATEGORY_CHOICES.reduce((acc, choice) => {
    acc[choice.value] = choice.label;
    return acc;
  }, {});

  const handleBack = () => {
    navigate('/admin/settings/additional-costs');
  };

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading subcategory details</div>;
  if (!data) return <div>No data found</div>;

  return (
    <div className="flex flex-col gap-5">
      <div className="mt-5 grid h-full">
        <div className="flex items-center justify-between">
          <Button
            startIcon={<BsArrowLeft />}
            onClick={handleBack}
            variant="text"
            className="!text-gray-600"
          >
            Back to List
          </Button>
          <Button
            component={Link}
            to={`/admin/settings/additional-costs/edit/${id}`}
            startIcon={<BsPencilSquare />}
            variant="contained"
            color="primary"
          >
            Edit
          </Button>
        </div>
        <h1 className="text-2xl font-bold text-navy-700 dark:text-white mt-3">
          Subcategory Details
        </h1>
        <p className="mt-2 text-base text-gray-600">
          View subcategory information
        </p>
      </div>

      <Card extra={'w-full h-full bg-white p-6'}>
        <div className="space-y-6">
          <div>
            <h3 className="text-lg font-semibold text-navy-700 dark:text-white mb-4">
              Subcategory Information
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="text-sm font-medium text-gray-600">Subcategory Name</label>
                <p className="mt-1 text-base font-semibold text-navy-700 dark:text-white">
                  {data.name}
                </p>
              </div>
              
              <div>
                <label className="text-sm font-medium text-gray-600">Category</label>
                <p className="mt-1 text-base font-semibold text-navy-700 dark:text-white">
                  {categoryDisplay[data.category] || data.category}
                </p>
              </div>
            </div>
            
            <div className="mt-4">
              <label className="text-sm font-medium text-gray-600">Subcategory Description</label>
              <p className="mt-1 text-base text-navy-700 dark:text-white">
                {data.description || 'No description provided'}
              </p>
            </div>
          </div>


          <div className="border-t pt-6">
            <h3 className="text-lg font-semibold text-navy-700 dark:text-white mb-4">
              Audit Information
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="text-sm font-medium text-gray-600">Created At</label>
                <p className="mt-1 text-base text-navy-700 dark:text-white">
                  {data.created_at ? new Date(data.created_at).toLocaleString() : 'N/A'}
                </p>
              </div>
              <div>
                <label className="text-sm font-medium text-gray-600">Created By</label>
                <p className="mt-1 text-base text-navy-700 dark:text-white">
                  {data.created_by_display || data.created_by || 'System'}
                </p>
              </div>
              <div>
                <label className="text-sm font-medium text-gray-600">Updated At</label>
                <p className="mt-1 text-base text-navy-700 dark:text-white">
                  {data.updated_at ? new Date(data.updated_at).toLocaleString() : 'N/A'}
                </p>
              </div>
              <div>
                <label className="text-sm font-medium text-gray-600">Updated By</label>
                <p className="mt-1 text-base text-navy-700 dark:text-white">
                  {data.updated_by_display || data.updated_by || 'System'}
                </p>
              </div>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default AdditionalCostSubcategoryView;